import { Link, withRouter, useHistory } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import Snackbars from '../../pages/Snackbars';
import React, { useState } from 'react';
import axios from 'axios';
import { checkauhtoken } from '../../../api/PrePageLoad';

function LogoutPage(props) {
    const { t } = useTranslation();
    const history = useHistory();
    const [error, setError] = useState(false);
	const [error_msg, setErrorMsg] = useState("");
	const [success, setSuccess] = useState(false);
	const [success_msg, setSuccessMsg] = useState("");


	const onLogout = () => {
		checkauhtoken();
		
		const headers = {
			'Content-Type': 'application/json',
			'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
			'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
		}
		axios.get(process.env.REACT_APP_API_URL + 'auth/logout', { headers: headers })
			.then(function (res) {
				res = res.data;
				if (res.code === "200") {
					window.sessionStorage.removeItem("user_id");
                    window.sessionStorage.removeItem("user_jwt");
                    window.sessionStorage.removeItem("register_user_id");
                    window.sessionStorage.removeItem("temp_login_id");

                    if (window.sessionStorage.getItem("demouser") === "Yes") {
                        window.sessionStorage.removeItem("demouser");
                        window.location.href = process.env.REACT_APP_SITE_URL + "demologin";
                    } else {
                        window.sessionStorage.removeItem("demouser");
                        window.location.href = process.env.REACT_APP_SITE_URL + "login";
                    }

				} else {
					setError(true);
					setErrorMsg(res.message);
					setTimeout(() => {
						setError(false);
					}, 6000);
				}
			})
			.catch(function (error) {
				setError(true);
				setErrorMsg(t('ERROR_MSG.SOMETHING'));
				setTimeout(() => {
					setError(false);
				}, 6000);
			});
	}

    return (
        <>
            {error ? <Snackbars open_close={error} type="error" message={error_msg} /> : ""}
			{success ? <Snackbars open_close={success} type="success" message={success_msg} /> : ""}
            <Link to="#" className="dropdown-item ai-icon" onClick={onLogout}>
                <svg
                    id="icon-logout" xmlns="http://www.w3.org/2000/svg"
                    className="text-danger" width={18} height={18} viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"
                >
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                    <polyline points="16 17 21 12 16 7" />
                    <line x1={21} y1={12} x2={9} y2={12} />
                </svg>
                <span className="ml-2" >{t('BUTTONS.LOGOUT')} </span>
            </Link>
        </>
    )
}

export default withRouter((LogoutPage));